import React from 'react';
import TemplateComponent, {TemplateComponentProps} from "../template_component/template_component";
import axios, {AxiosResponse} from "axios";

interface DoubleTemplateComponentData {
    __data: string;
    __other_data: string[];
}

/**
 * Extend the DoubleTemplateComponent if your component is a TemplateComponent
 * which needs to fetch its data url before fetching its data.
 */
class DoubleTemplateComponent<D = any, D2 = any> extends TemplateComponent<D, TemplateComponentProps<D>> {

    nextDataLoaded = false;

    componentDidMount(): void {
        this.doubleFetch();
    }

    componentDidUpdate(prevProps: Readonly<TemplateComponentProps<D>>, prevState: any, snapshot?: any): void {
        if (this.props.url !== prevProps.url) {
            if (this.props.url) {
                this.dataUrl = this.props.url;
            }

            this.doubleFetch();
        }
    }

    private doubleFetch() {
        if (!this.props.data && this.dataUrl) {
            this.fetchData(this.dataUrl).then(this.doubleFetchWithData);
        }
    }

    doubleFetchWithData = (data: DoubleTemplateComponentData, saveLinks: boolean = true) => {
        if (!data) return;

        if (data.__other_data) {
            data.__other_data.forEach((link, index) => {
                return axios.get(link)
                    .then((otherData: AxiosResponse<D2>) => {
                        if (!otherData || !otherData.data) return null;
                        return this.onOtherDataLoaded(index, otherData.data);
                    });
            });
        }

        if (data.__data) {
            return this.fetchData(data.__data)
                .then(nextData => {
                    if (!nextData) return null;

                    this.nextDataLoaded = true;
                    let allData = saveLinks ? {...data, ...nextData} : nextData;
                    this.setState({data: allData});
                    return this.onDataLoaded(allData);
                });
        }
    };

    onOtherDataLoaded(index: number, data: D2) {}

    render() {
        if (!this.nextDataLoaded) return <div />;

        return super.render();
    }
}

export default DoubleTemplateComponent;
